//Library Imports
import { useHistory } from "react-router-dom";

//Local Imports
import { Tooltip } from "antd";
import { DEFAULT_IMAGE_PLACEHOLDER } from "constants/index";
import { ReactComponent as Send } from "../../../assets/img/icons/SendingWhite.svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { ReactComponent as Mail } from "../../../assets/img/icons/mail.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import ShareMenuPopup from "modules/Common/Components/ShareMenuPopup";
import { removeOnClickBubble } from "utils";
import { IListItem } from "../Audience/interface";

//Style Imports
import styled from "styled-components";
import { resetAudienceListDetailsProfiled, resetAudienceListDetailsNonProfiled } from "../Audience/Lists/actions";

interface IListItemProps {
  key: number;
  item: IListItem;
  classname?: string;
  added?: number;
  isList?: boolean;
  handleOnClick?: any;
  externalPopover?: any;
  handleAddPeople?: any;
  setTabState?: (value: string) => void;
}

const ListItem: React.FC<IListItemProps> = (props) => {
  const { item, classname, added = false, handleOnClick, handleAddPeople, setTabState } = props;
  const history = useHistory();
  let cardClass = added ? "disabled" : classname;
  const thumb1 = item?.topContactsThumbnail
    ? item?.topContactsThumbnail[0]
    : "https://media.xiq.io/static/default_campaign_img.png";
  const thumb2 = item?.topContactsThumbnail
    ? item?.topContactsThumbnail[1]
    : "https://media.xiq.io/static/default_campaign_img.png";
  const thumb3 = item?.topContactsThumbnail
    ? item?.topContactsThumbnail[2]
    : "https://media.xiq.io/static/default_campaign_img.png";

  const redirect = (listId: number) => {
    if (setTabState) setTabState("profiled");
    resetAudienceListDetailsProfiled();
    resetAudienceListDetailsNonProfiled();
    if (window.location.pathname.includes("/audiences/lists")) {
      history.push(`/audiences/lists/view?list_id=${listId}`);
    } else if (handleAddPeople) {
      handleAddPeople(item?.id, item?.name, "list");
    } else if (props.handleOnClick) {
      handleOnClick();
    } else {
      history.push(`/audiences/lists/view?list_id=${listId}`);
    }
  };
  return (
    <Wrapper
      className={`${cardClass === undefined ? "" : cardClass}`}
      style={{ cursor: added ? "auto" : "pointer" }}
      onClick={!added ? () => redirect(item?.id ?? 0) : undefined}
    >
      <div className="blog-image">
        {thumb1 ? (
          <div
            className="img1 img-bg"
            style={{
              backgroundImage: `url(${thumb1 || DEFAULT_IMAGE_PLACEHOLDER})`,
            }}
          />
        ) : (
          <img
            className="img1"
            src={thumb1 || "https://media.xiq.io/static/default_campaign_img.png"}
            alt="img1"
          />
        )}

        <div className="right-images">
          {thumb2 ? (
            <div
              className="img2 img-bg"
              style={{
                backgroundImage: `url(${thumb2 || DEFAULT_IMAGE_PLACEHOLDER})`,
              }}
            />
          ) : (
            <img
              className="img2"
              src={thumb2 || "https://media.xiq.io/static/default_campaign_img.png"}
              alt="img2"
            />
          )}

          {thumb3 ? (
            <div
              className="img3 img-bg"
              style={{
                backgroundImage: `url(${thumb3 || DEFAULT_IMAGE_PLACEHOLDER})`,
              }}
            />
          ) : (
            <img
              className="img3"
              src={thumb3 || "https://media.xiq.io/static/default_campaign_img.png"}
              alt="img3"
            />
          )}
        </div>
      </div>
      <div className="details">
        <>
          <div className="list-name">
            <Tooltip placement="top" title={item.name}>
              {item?.name?.startsWith("[Cloned]") ? (
                <span>
                  <span style={{ color: "#1EC252" }}>[Cloned]</span> {item?.name.substring(8)}
                </span>
              ) : (
                item?.name
              )}
            </Tooltip>
          </div>
          <div className="recipient-count">
            <span> {`${item.campaignsCount} link(s)`} </span>
            <span className="last-updated"> | {item.lastUpdated} </span>
          </div>
        </>
      </div>
      <div className="actions d-flex justify-content-end">
        <div className="icons-wrapper">
          <div className="actions d-flex justify-content-between">
            <ul>
              <li>
                <a>
                  <Audience />
                  <span className="qa-total-listitem">{item?.totalContacts ?? 0}</span>
                </a>
              </li>
              <li>
                <a>
                  <Send />
                  <span>{item?.totalSent ?? 0}</span>
                </a>
              </li>
              {/* <li>
                <a>
                  <Mail />
                  <span>{item?.totalDelivered ?? 0}</span>
                </a>
              </li>
              <li>
                <a>
                  <Eye />
                  <span>{item?.totalOpens ?? 0}</span>
                </a>
              </li> */}
              <li>
                <a>
                  <Click />
                  <span>{item?.totalClicks ?? 0}</span>
                </a>
              </li>
              <li className="card-popover">
                {!window.location.pathname.includes("campaigns") &&
                  (props.externalPopover ? (
                    props.externalPopover()
                  ) : (
                    <ShareMenuPopup data={props}>
                      <a onClick={removeOnClickBubble}>
                        <Elipsis />
                      </a>
                    </ShareMenuPopup>
                  ))}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ListItem;

const Wrapper = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
  padding: 14px 13px 14px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
    padding: 10px 12px;
    max-height: 83px;
    min-height: 83px;
  }
  .blog-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .blog-image {
    .img1 {
      height: 70px;
      width: 52px;
      border-radius: 6px 0px 0px 6px;
      margin-right: 2px;
      @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 4px 0px 0px 4px;
        height: 50px;
        width: 36px;
      }
    }
    .img-bg {
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .right-images {
      .overlayed-image {
        position: absolute;
        left: 9%;
        top: 22%;
      }
      .img-bg {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      display: flex;
      flex-direction: column;
      .img2 {
        height: 34px;
        width: 39px;
        border-radius: 0px 6px 0px 0px;
        margin-bottom: 1px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 4px 0px 0px;
          height: 25px;
          width: 28px;
        }
      }
      .img3 {
        height: 34px;
        width: 39px;
        border-radius: 0px 0px 6px 0px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 0px 4px 0px;
          height: 23px;
          width: 28px;
        }
      }
    }
  }
  .disabled {
    pointer-events: none !important;
    background-color: rgba(225, 225, 225, 0.7) !important;
    cursor: no-drop;
  }
  .preview {
    position: relative;
    max-width: 55px;
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
    img {
      border-radius: 100%;
      max-width: 100%;
      height: 51px;
      width: 51px;
      min-width: 51px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 36px;
        width: 36px;
        min-width: 36px;
      }
    }
  }
  .details {
    padding-left: 15px;
    max-width: calc(100% - 400px);
    .name,
    .company,
    .designation,
    .last-updated {
      color: #7e7e7e;
    }
    .recipient-count {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0px;
      -webkit-box-align: start;
      width: 100%;
      word-break: break-word;
    }
    .name {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 15px;
        font-size: 13px;
      }
    }
    .list-name {
      /* color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 14px;
        font-size: 13px;
      } */
      > span {
        color: #000000;
        font-size: 20px;
        font-weight: 400;
        font-family: "Roboto Slab", serif;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        max-width: 100%;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          line-height: 15px;
          font-size: 13px;
        }
      }
    }
    .company {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #424b50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .designation {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .recipient-count {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
  }
  .actions {
    min-width: 50px;
    &.dot-campaign {
      .dot-campaign {
        padding-top: 0px;
      }
    }
    .dot-item {
      margin-left: 60px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-right: 0;
      }
    }
    ul {
      list-style: none;
      margin: 0 -10px;
      padding: 0;
      li {
        float: left;
        display: inline-block;
        padding: 0 3px;
        width: 50px;
        @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 0;
        }
        a {
          padding: 0 5px;
          text-align: center;
          display: block;
          @media all and (max-width: 1300px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 0 3px;
          }
          svg {
            width: 18px;
            max-height: 12px;
            @media all and (max-width: 1300px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 9px;
            }
            path {
              fill: #000000;
              opacity: 0.5;
            }
            g {
              opacity: 1;
            }
          }
          span {
            color: #5e7079;
            font-size: 10px;
            font-family: "helveticaneuebold";
            font-weight: 700;
            display: block;
            text-align: center;
            @media all and (max-width: 1300px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 8px;
            }
          }
        }
        &.card-popover {
          float: right;
          padding-top: 7px;
          width: auto;
          a {
            svg,
            img {
              width: 5px;
              max-height: none;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 4px;
              }
            }
          }
        }
        &:hover {
          a {
            svg path {
              fill: #27ce0a;
              opacity: 1;
            }
          }
        }
      }
    }
    -ms-flex-negative: 1;
    flex-shrink: 1;
    align-self: center;
    margin-left: auto;
    min-width: 106px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      width: 100%;
      li {
        float: left;
        display: inline-block;
        padding: 0px;
        &.clicks {
          padding-right: 10px;
          .container-span {
            font-family: "Roboto", sans-serif;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            background-color: #1971eb;
            border-radius: 12px;
            padding: 0px 10px;
            display: inline-flex;
            width: 80px;
            height: 22px;
            justify-content: center;
            align-items: center;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 11px;
              width: 70px;
            }
            svg {
              vertical-align: baseline;
              margin-right: 5px;
            }
          }
        }
        &.card-popover {
          a {
            padding: 0 5px;
            svg {
              width: 5px;
              max-height: none;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 4px;
              }
            }
          }
        }
      }
    }
  }
`;
